import { Button, CircularProgress, FormControl, Grid, TextField, useTheme } from '@mui/material';
import { Controller, FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import React from 'react';
import { ProcureUser } from 'vendor-marketplace-shared-library';

type UserDetailsFormProps = {
  onSubmit: SubmitHandler<FieldValues>;
  loading: boolean;
  user?: ProcureUser;
};

export default function UserDetailsForm(props: UserDetailsFormProps) {
  const theme = useTheme();
  const form = useForm({
    defaultValues: { firstName: props.user?.firstName || '', lastName: props.user?.lastName || '' },
  });

  return (
    <form onSubmit={form.handleSubmit(props.onSubmit)}>
      <Grid container sx={styles.mainContainer}>
        <Grid item>
          <Controller
            name='firstName'
            control={form.control}
            rules={{ min: 1 }}
            render={({ field }) => (
              <FormControl fullWidth>
                <TextField multiline label={'First name'} {...field} size={'small'} />
              </FormControl>
            )}
          />
        </Grid>
        <Grid item>
          <Controller
            name='lastName'
            control={form.control}
            rules={{ min: 1 }}
            render={({ field }) => (
              <FormControl fullWidth>
                <TextField multiline label={'Last name'} {...field} size={'small'} />
              </FormControl>
            )}
          />
        </Grid>
        <Grid item sx={styles.fullWidth}>
          <Button sx={styles.fullWidth} variant={'contained'} type='submit'>
            {props.loading ? (
              <CircularProgress size={20} sx={{ color: theme.palette.background.default }} />
            ) : (
              'Create Account'
            )}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}

const styles = {
  mainContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: 2,
  },
  fullWidth: {
    width: '100%',
  },
};
